import { useStyles } from './styles'
const FieldStatusText = (props) => {
  const { statustext } = props
  const classes = useStyles()
  return <div className={classes.layout}>{statustext}</div>
}
export default FieldStatusText
